import uniq from 'lodash/uniq'
import { CALL_API, REQUEST_GET, REQUEST_POST } from '../middleware/api'
import { NONE, PROJECT, PROJECT_COLLECTION } from '../schemas/index'
import { createSearch } from './searchActions'
import { SUCCESS } from '../components/AlertListItem'
import { buildBaseURL } from '../utils/urlHelper'

export const ADD_PROJECT_TO_WORKSPACE_REQUEST =
  'ADD_PROJECT_TO_WORKSPACE_REQUEST'
export const ADD_PROJECT_TO_WORKSPACE_SUCCESS =
  'ADD_PROJECT_TO_WORKSPACE_SUCCESS'
export const ADD_PROJECT_TO_WORKSPACE_FAILURE =
  'ADD_PROJECT_TO_WORKSPACE_FAILURE'
export const CLEAR_SELECTED_PROJECTS = 'tru/projects/CLEAR_SELECTED_PROJECTS'
export const PROJECT_REQUEST = 'PROJECT_REQUEST'
export const PROJECT_SUCCESS = 'PROJECT_SUCCESS'
export const PROJECT_FAILURE = 'PROJECT_FAILURE'
export const FETCH_PROJECTS_REQUEST = 'tru/projects/FETCH_PROJECTS_REQUEST'
export const FETCH_PROJECTS_SUCCESS = 'tru/projects/FETCH_PROJECTS_SUCCESS'
export const FETCH_PROJECTS_FAILURE = 'tru/projects/FETCH_PROJECTS_FAILURE'
export const TOGGLE_PROJECT = 'tru/projects/TOGGLE_PROJECT'

export function addProjectToWorkspace(company, project, workspace) {
  const workspaceURL = buildBaseURL(`workspaces/${workspace.id}`)
  return {
    [ADD_PROJECT_TO_WORKSPACE_SUCCESS]: {
      entities: {
        projects: {
          [project.id]: {
            workspaces: uniq([...project.workspaces, workspace.id])
          }
        }
      },
      alert: {
        type: SUCCESS,
        message: `Added to ${workspace.name}. <a href="${workspaceURL}">View it now!</a>`,
        htmlSafe: true
      }
    },
    [CALL_API]: {
      types: [
        ADD_PROJECT_TO_WORKSPACE_REQUEST,
        ADD_PROJECT_TO_WORKSPACE_SUCCESS,
        ADD_PROJECT_TO_WORKSPACE_FAILURE
      ],
      endpoint: `companies/${company.id}/workspaces/${workspace.id}/projects/${project.id}.json`,
      requestType: REQUEST_POST,
      schema: NONE
    }
  }
}

export function fetchProject(company, id) {
  return {
    [CALL_API]: {
      types: [PROJECT_REQUEST, PROJECT_SUCCESS, PROJECT_FAILURE],
      endpoint: `companies/${company.id}/projects/${id}.json`,
      requestType: REQUEST_GET,
      schema: PROJECT
    }
  }
}

export function searchProject(company, project) {
  return createSearch(company, {
    filters: [{ projectGroupIds: [project.id] }],
    displayed: [
      {
        name: 'Project',
        applied: [{ id: project.id, name: project.name, applied: true }]
      }
    ]
  })
}

export const fetchProjectsInCompany = company => ({
  [CALL_API]: {
    types: [
      FETCH_PROJECTS_REQUEST,
      FETCH_PROJECTS_SUCCESS,
      FETCH_PROJECTS_FAILURE
    ],
    endpoint: `companies/${company.id}/projects.json`,
    requestType: REQUEST_GET,
    schema: PROJECT_COLLECTION
  }
})

// Implemented as part of "quick and dirty" add user to company interface
//   Rethink when overhauling with a more complete solution
export const fetchAdminProjectsInCompany = company => ({
  [CALL_API]: {
    types: [
      FETCH_PROJECTS_REQUEST,
      FETCH_PROJECTS_SUCCESS,
      FETCH_PROJECTS_FAILURE
    ],
    endpoint: `admin/companies/${company.id}/projects.json`,
    requestType: REQUEST_GET,
    schema: PROJECT_COLLECTION
  }
})

export const toggleProject = (projectId, selected) => ({
  type: TOGGLE_PROJECT,
  projectId,
  selected
})

export const clearSelectedProjects = () => ({ type: CLEAR_SELECTED_PROJECTS })



// WEBPACK FOOTER //
// ../src/actions/projectActions.js